import type { UserOperation } from 'viem/account-abstraction';

type CalculateGasForUserOperationParams = {
  userOperationData: Pick<
    UserOperation,
    | 'callGasLimit'
    | 'verificationGasLimit'
    | 'preVerificationGas'
    | 'maxFeePerGas'
  >;
};

export const calculateGasForUserOperation = ({
  userOperationData,
}: CalculateGasForUserOperationParams): bigint => {
  // Sum all gas units
  const totalGasUnits =
    userOperationData.callGasLimit +
    userOperationData.verificationGasLimit +
    userOperationData.preVerificationGas;

  // Multiply by maxFeePerGas to get the total gas cost in wei
  const gasCost = totalGasUnits * userOperationData.maxFeePerGas;

  return gasCost;
};
